import { createFileRoute } from '@tanstack/react-router';

import { TicketHistoryPage } from '../modules/ticket-history/ui/pages/TicketHistoryPage';

// NOTE: .index.tsx suffix is REQUIRED (same pattern as checkin-config + tip-config routes).
// Without the .index suffix, TanStack Router treats the file as a layout component.
export const Route = createFileRoute('/_authenticated/dashboard/tickets/$ticketId/history/')({
  component: TicketHistoryPage,
  staticData: {
    breadcrumb: ['Audit', 'Ticket History'],
  },
});
